<script setup lang="ts">
defineOptions({
  name: 'ReferenzenComponent'
})

const { elementReference, isReady, isRevealed } = useScrollReveal()
</script>

<template>
  <div
    ref="elementReference"
    :class="['px-0 py-0 mx-0 my-0', { reveal: isReady, revealed: isRevealed }]"
  >
    <div class="pt-high">
      <v-row class="fill-height" no-gutters>
        <v-col cols="0" lg="6" class="d-none d-lg-block">
          <v-row no-gutters>
            <v-col cols="6" lg="5">
              <NuxtImg
                class="pr-lg-16 w-100"
                src="/images/Bueroleben1.jpg"
                alt="Büroleben - Teamarbeit im Architekturbüro"
                loading="lazy"
              />
            </v-col>
            <v-spacer />
            <v-col class="pr-lg-16" cols="6" lg="5">
              <NuxtImg
                class="w-100"
                src="/images/Bueroleben2.jpg"
                alt="Büroleben - Gemeinsame Aktivitäten"
                loading="lazy"
              />
            </v-col>
            <v-spacer />
          </v-row>
          <v-row class="h-50" no-gutters>
            <v-col cols="12">
              <div class="d-flex align-center justify-start h-100 px-12">
                <div>
                  <h3 class="text-primary bannerTitle font-weight-regular mb-8">Büroleben</h3>
                  <p class="text-body-1 mb-4">
                    Von unseren Büroräumen und auf den Baustellen arbeiten wir für sie fast rund um
                    die Uhr. So gesehen ist das Büro unser zweites zu Hause. Daher genießen wir
                    nicht nur die schöne Dinge um uns herum sondern nehmen uns die Auszeiten bei
                    gemeinsamen Frühstücken oder Feiern. Auch verknüpfen wir die Fortbildungen gerne
                    mit unseren jährlichen Büroausflügen und lassen und durch unseren
                    Physiotherapeuten die Verspannungen weg kneten.
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="6">
          <div class="image-container">
            <NuxtImg
              class="w-100"
              src="/images/Bueroleben3.jpg"
              alt="Büroleben - Architekturprojekte"
              loading="lazy"
            />
            <NuxtLink to="/referenzen" aria-label="Referenzen anzeigen">
              <div class="white-square">
                <v-icon class="chevron" icon="mdi-chevron-right" aria-hidden="true" />
              </div>
            </NuxtLink>
          </div>
        </v-col>
        <v-col cols="12" lg="0">
          <div class="d-flex align-center h-100 px-8 pt-6 d-lg-none">
            <div>
              <h3 class="text-primary bannerTitle font-weight-regular mb-8">Büroleben</h3>
              <p class="text-body-1 mb-4">
                Von unseren Büroräumen und auf den Baustellen arbeiten wir für sie fast rund um die
                Uhr. So gesehen ist das Büro unser zweites zu Hause. Daher genießen wir nicht nur
                die schöne Dinge um uns herum sondern nehmen uns die Auszeiten bei gemeinsamen
                Frühstücken oder Feiern. Auch verknüpfen wir die Fortbildungen gerne mit unseren
                jährlichen Büroausflügen und lassen und durch unseren Physiotherapeuten die
                Verspannungen weg kneten.
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style scoped lang="scss">
.chevron {
  margin: auto;
  align-self: center;
  font-size: calc(min(20vw, 150px) * 0.5);
  color: rgba(var(--v-theme-primary), 1);
}
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.white-square {
  display: flex;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20%;
  max-width: 150px;
  aspect-ratio: 1/1;
  background-color: white;
}
</style>
